var t = String, e = function(r) {
  try {
    return t(r);
  } catch {
    return "Object";
  }
};
export {
  e as t
};
